(function () {
  'use strict';

  /* The catalogue-derived lists are printed into the page by
     snippets/putp-cart-drawer.liquid, because an asset file cannot read
     the shop's collections. */
  var DATA = window.PUTP_CD_DATA || {};
  var OPEN_ENTRIES = DATA.openEntries || [];
  var SUGGEST = DATA.suggest || [];

  var TIER1_OFF = 1000;   // cents - any 2 entries
  var TIER2_OFF = 1500;   // cents - hoodie + tee

  var root   = document.getElementById('putp-cd');
  if (!root) return;
  var veil   = document.getElementById('putp-cd-veil');
  var closeB = document.getElementById('putp-cd-x');
  var body   = document.getElementById('putp-cd-body');
  var foot   = document.getElementById('putp-cd-foot');
  var countE = document.getElementById('putp-cd-count');
  var totalE = document.getElementById('putp-cd-total');
  var saveE  = document.getElementById('putp-cd-save');
  var saveR  = document.getElementById('putp-cd-saverow');
  var rewards= document.getElementById('putp-cd-rewards');
  var msgE   = document.getElementById('putp-cd-msg');
  var fillE  = document.getElementById('putp-cd-fill');
  var stop1  = document.getElementById('putp-cd-stop1');
  var stop2  = document.getElementById('putp-cd-stop2');
  var noteE  = document.getElementById('putp-cd-note');
  var alsoW  = document.getElementById('putp-cd-also');
  var alsoR  = document.getElementById('putp-cd-also-row');
  var goB    = document.getElementById('putp-cd-go');

  var lastFocus = null;
  var busy = false;

  function money(cents) {
    var n = (cents / 100);
    return '$' + n.toFixed(n % 1 === 0 ? 0 : 2);
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function reward(cart) {
    var entries = 0, hoodie = false, tee = false;
    (cart.items || []).forEach(function (it) {
      if (OPEN_ENTRIES.indexOf(it.product_id) !== -1) entries += it.quantity;
      // else-if matters: "Hooded Sweatshirt" contains "shirt", so without it a
      // hoodie counts as a tee too and a lone hoodie falsely claims the $15.
      var t = (it.product_type || '').toLowerCase().trim();
      if (t.indexOf('hood') !== -1 || t.indexOf('sweat') !== -1) hoodie = true;
      else if (t.indexOf('shirt') !== -1 || t.indexOf('tee') !== -1) tee = true;
    });
    var spread = hoodie && tee;
    var anyTwo = entries >= 2;
    return {
      entries: entries, spread: spread, anyTwo: anyTwo,
      off: spread ? TIER2_OFF : (anyTwo ? TIER1_OFF : 0)
    };
  }

  function paintRewards(cart) {
    var r = reward(cart);
    if (!cart.item_count) { rewards.hidden = true; return r; }
    rewards.hidden = false;

    var pct, msg;
    if (r.spread) {
      pct = 100;
      msg = '<b>$15 off</b> &mdash; applied at checkout.';
    } else if (r.anyTwo) {
      pct = 58;
      msg = '<b>$10 off</b> unlocked. add a hoodie to a tee and it’s <b>$15</b> instead.';
    } else if (r.entries === 1) {
      pct = 26;
      msg = 'add one more entry and save <b>$10</b>.';
    } else {
      pct = 0;
      msg = 'two entries save you <b>$10</b>. a hoodie and a tee save <b>$15</b>.';
    }

    fillE.style.width = pct + '%';
    msgE.innerHTML = msg;
    stop1.className = 'putp-cd__stop' + (r.anyTwo ? ' is-hit' : '');
    stop2.className = 'putp-cd__stop' + (r.spread ? ' is-hit' : '');
    noteE.hidden = !(r.anyTwo || r.spread);
    return r;
  }

  function paint(cart) {
    countE.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

    if (!cart.item_count) {
      body.innerHTML = '<p class="putp-cd__empty">nothing here yet.</p>';
      foot.hidden = true; alsoW.hidden = true; rewards.hidden = true;
      return;
    }

    var html = '';
    (cart.items || []).forEach(function (it, i) {
      var opts = (it.options_with_values || [])
        .map(function (o) { return o.value; })
        .filter(function (v) { return v && v !== 'Default Title'; })
        .join(' · ');
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      html +=
        '<div class="putp-cd__item" data-line="' + (i + 1) + '">' +
          (img ? '<img class="putp-cd__thumb" src="' + esc(img) + '" alt="" loading="lazy">' : '<div class="putp-cd__thumb"></div>') +
          '<div class="putp-cd__info">' +
            '<p class="putp-cd__name">' + esc(it.product_title) + '</p>' +
            (opts ? '<p class="putp-cd__opt">' + esc(opts) + '</p>' : '') +
            (it.final_line_price === 0
              ? '<span class="putp-cd__price putp-cd__price--free">free</span>' +
                '<span class="putp-cd__badge">included</span>'
              : '<span class="putp-cd__price">' + money(it.final_line_price) + '</span>') +
            '<div class="putp-cd__ctl">' +
              '<button class="putp-cd__q" data-act="dec" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="putp-cd__qn">' + it.quantity + '</span>' +
              '<button class="putp-cd__q" data-act="inc" aria-label="Increase quantity">+</button>' +
              '<button class="putp-cd__rm" data-act="rm">remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    body.innerHTML = html;

    paintRewards(cart);

    totalE.textContent = money(cart.total_price);
    var saved = (cart.total_discount || 0);
    if (saved > 0) { saveR.hidden = false; saveE.textContent = '−' + money(saved); }
    else { saveR.hidden = true; }
    foot.hidden = false;

    var inCart = (cart.items || []).map(function (it) { return it.product_id; });
    var picks = SUGGEST.filter(function (s) { return inCart.indexOf(s.id) === -1; }).slice(0, 4);
    if (picks.length) {
      alsoR.innerHTML = picks.map(function (s) {
        return '<a class="putp-cd__also-card" href="' + esc(s.u) + '">' +
          '<img class="putp-cd__also-img" src="' + esc(s.img) + '" alt="" loading="lazy">' +
          '<p class="putp-cd__also-t">' + esc(s.t) + '</p>' +
          '<p class="putp-cd__also-p">' + money(s.p) + '</p></a>';
      }).join('');
      alsoW.hidden = false;
    } else { alsoW.hidden = true; }
  }

  function load(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paint(cart);
        syncBadge(cart.item_count);
        if (open) show();
        return cart;
      })
      .catch(function () {});
  }

  function change(line, qty) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(cart); syncBadge(cart.item_count); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function syncBadge(n) {
    document.querySelectorAll(
      '[data-cart-count], .cart-count, .putp-cart-count, .header__cart-count, .cart-bubble__text'
    ).forEach(function (el) { el.textContent = n; });
  }

  function show() {
    if (!root.hidden) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    root.offsetWidth;
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { closeB.focus(); }, 60);
  }

  function hide() {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  veil.addEventListener('click', hide);
  closeB.addEventListener('click', hide);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) hide();
  });

  body.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    var row = b.closest('[data-line]');
    if (!row) return;
    var line = parseInt(row.dataset.line, 10);
    var now = parseInt(row.querySelector('.putp-cd__qn').textContent, 10) || 1;
    var act = b.dataset.act;
    if (act === 'inc') change(line, now + 1);
    else if (act === 'dec') change(line, Math.max(0, now - 1));
    else if (act === 'rm') change(line, 0);
  });

  goB.addEventListener('click', function () { window.location.href = '/checkout'; });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = (a.getAttribute('href') || '').replace(/^https?:\/\/[^\/]+/, '');
    if (!/^\/cart\/?(\?|$)/.test(href)) return;
    e.preventDefault();
    e.stopPropagation();
    load(true);
  }, true);

  var prevSync = window.PUTP_CART_SYNC;
  window.PUTP_CART_SYNC = function () {
    if (typeof prevSync === 'function') { try { prevSync(); } catch (err) {} }
    load(true);
  };
  window.PUTP_CART_OPEN = function () { load(true); };

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (f.hasAttribute('data-type')) return;      // product.liquid handles its own
    e.preventDefault();
    var fd = new FormData(f);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function () { load(true); })
      .catch(function () { f.submit(); });
  }, true);

  load(false);
})();